var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/markup.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Text from './ui/text/text';
import './markup.css';

/** Styles HTML markup returned by the API, such as in account bios and statuses. */
const Markup = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(Text, _extends({
    ref: ref
  }, props, {
    "data-markup": true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }));
});
export default Markup;